module.exports = __webpack_public_path__ + "static/img/index-yuyue.0127898d.png";